import React, { Component } from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  Checkbox,
} from "react-bootstrap";
import Popup from "reactjs-popup";
import * as constants from "../../constants";
import {
  getReposByClientId,
  getListRoles,
  signUp,
  updateUserRoles,
} from "../../libs/API";

class CreateUserPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpen: false,
      userEmail: "",
      userPassword: "",
      confirmPassword: "",
      errorMessage: "",
      addingUser: false,
      availableRepos: [],
      selectedRepos: [],
      availableRoles: [],
      selectedRoles: [],
      clientId: this.props.clientId,

      // Additional Cognito fields
      name: "", // First Name
      familyname: "", // Last Name
      title: "", // custom:title
      department: "", // custom:department
      division: "", // custom:division
    };
    this.closePopup = this.closePopup.bind(this);
  }

  async componentDidMount() {
    this.setState({ popupOpen: this.props.props.showCreateUserPopup });

    const [repos, roles] = await Promise.all([
      getReposByClientId(this.state.clientId).catch(() => []),
      getListRoles(this.state.clientId, this.props.loggedInUser).catch(
        () => [],
      ),
    ]);
    this.setState({
      availableRepos: repos || [],
      availableRoles: roles || [],
    });
  }

  closePopup() {
    this.setState({ popupOpen: false });
    this.props.unmountMe();
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value, errorMessage: "" });
  };

  handleRepoSelection = (e) => {
    const repoNodeId = e.target.id;
    const checked = document.getElementById(repoNodeId).checked;
    let { availableRepos, selectedRepos } = this.state;

    if (checked) {
      const selectedRepo = availableRepos.find(
        (r) => r.nodeId.toString() === repoNodeId,
      );
      selectedRepos.push(selectedRepo);
    } else {
      selectedRepos = selectedRepos.filter(
        (r) => r.nodeId.toString() !== repoNodeId,
      );
    }
    this.setState({ selectedRepos });
  };

  handleRoleSelection = (e) => {
    const roleNodeId = parseInt(e.target.id, 10);
    const checked = document.getElementById(e.target.id).checked;
    let { availableRoles, selectedRoles } = this.state;

    if (checked) {
      const selectedRole = availableRoles.find((r) => r.roleId === roleNodeId);
      if (
        selectedRole &&
        !selectedRoles.some((r) => r.roleId === selectedRole.roleId)
      ) {
        selectedRoles.push(selectedRole);
      }
    } else {
      selectedRoles = selectedRoles.filter((r) => r.roleId !== roleNodeId);
    }
    this.setState({ selectedRoles });
  };

  handleAddUser = async (e) => {
    e.preventDefault();
    this.setState({ successMessage: "", errorMessage: "" });
    const emails = this.state.userEmail
      .split(";")
      .map((e) => e.trim())
      .filter((e) => e);

    const firstNames = this.state.name
      .split(";")
      .map((n) => n.trim())
      .filter((n) => n);

    const lastNames = this.state.familyname
      .split(";")
      .map((n) => n.trim())
      .filter((n) => n);

    // Email required
    if (emails.length === 0) {
      this.setState({
        errorMessage: "Please enter at least one email.",
      });
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (let i = 0; i < emails.length; i++) {
      if (!emailRegex.test(emails[i])) {
        this.setState({
          errorMessage: `Invalid email format: ${emails[i]}`,
        });
        return;
      }
    }

    // First name count validation
    if (firstNames.length > 0 && firstNames.length !== emails.length) {
      this.setState({
        errorMessage: "Number of First Names must match number of Emails.",
      });
      return;
    }

    // Last name count validation
    if (lastNames.length > 0 && lastNames.length !== emails.length) {
      this.setState({
        errorMessage: "Number of Last Names must match number of Emails.",
      });
      return;
    }

    // Basic password validations
    if (!this.state.confirmPassword.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) {
      this.setState({
        errorMessage: "Minimum 8 characters including 1 number.",
      });
      return;
    }
    if (this.state.userPassword !== this.state.confirmPassword) {
      this.setState({ errorMessage: constants.PASSWORD_MATCH_INVALID });
      return;
    }

    this.setState({ addingUser: true });

    // Prepare user details, including new Cognito fields
    const userDetails = {
      userEmail: this.state.userEmail,
      userPassword: this.state.userPassword,
      repos: this.state.selectedRepos,
      clientId: this.state.clientId,
      Name: this.state.name, // Standard Cognito attribute: First Name
      Familyname: this.state.familyname, // Standard Cognito attribute: Last Name
      Title: this.state.title, // Custom attribute
      DepartmentName: this.state.department,
      Division: this.state.division,
    };

    signUp(userDetails).then(async (data) => {
      let dataText = "";
      if (data.status === 200) {
        dataText = await data.text();
        let users = dataText.split(",");
        for (let i = 0; i < users.length; i++) {
          const [userId, userEmail] = users[i].split("|");
          //const userId = dataText.split("|")[0];
          //const userEmail = dataText.split("|")[1];
          if (this.state.selectedRoles.length > 0) {
            await updateUserRoles(
              userId,
              this.state.selectedRoles.map((role) => role.roleId),
              this.state.clientId,
              userEmail,
              "",
            );
          }
          let addNewRow = {
            email: userEmail,
            roles: this.state.selectedRoles,
            userId: userId,
          };
          this.props.handleNewRowInUserList(addNewRow);
        }
      } else {
        dataText = await data.text();
      }
      this.setState({ addingUser: false });
      this.closePopup();
      alert(dataText);
    });
  };

  formatGroupName = (groupname) => {
    if (groupname === "DocumentSync_OCR" || groupname === "DocumentSync_PII") {
      return groupname.replace(/^DocumentSync_/, "");
    } else if (groupname === "DocumentSync_RestrictAccessByIP") {
      return groupname
        .replace(/^DocumentSync_/, "")
        .replace(/(?<=[a-z])(?=[A-Z0-9])/g, " ");
    } else {
      return groupname
        .replace(/^DocumentSync_/, "")
        .replace(/([A-Z])(?=[a-z0-9])/g, " $1")
        .trim();
    }
  };

  renderCreateUser() {
    return (
      <div>
        <h3 className="mb-3">Add New User</h3>
        <hr />
        <Row>
          {/* Left Column: Form Fields */}
          <Col md={6}>
            <form onSubmit={this.handleAddUser}>
              <FormGroup
                controlId="userEmail"
                className="mb-3 create-user-popup"
              >
                <ControlLabel>Email(s):</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="Email(s) separated by semicolon if multiple)"
                  required
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* First Name */}
              <FormGroup controlId="name" className="mb-3 create-user-popup">
                <ControlLabel>First Name(s):</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="FirstName(s) separated by semicolon if multiple)"
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Last Name */}
              <FormGroup
                controlId="familyname"
                className="mb-3
                create-user-popup"
              >
                <ControlLabel>Last Name(s):</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="LastName(s) separated by semicolon if multiple)"
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Title */}
              <FormGroup controlId="title" className="mb-3 create-user-popup">
                <ControlLabel>Title:</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="Title"
                  disabled={this.state.userEmail.includes(";")}
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Department */}
              <FormGroup
                controlId="department"
                className="mb-3 create-user-popup"
              >
                <ControlLabel>Department:</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="Department"
                  disabled={this.state.userEmail.includes(";")}
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Division */}
              <FormGroup
                controlId="division"
                className="mb-3 create-user-popup"
              >
                <ControlLabel>Division:</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="Division"
                  disabled={this.state.userEmail.includes(";")}
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Password */}
              <FormGroup controlId="userPassword" className="mb-3">
                <ControlLabel>Password:</ControlLabel>
                <FormControl
                  type="password"
                  placeholder="Password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Confirm Password */}
              <FormGroup controlId="confirmPassword" className="mb-3">
                <ControlLabel>Confirm Password:</ControlLabel>
                <FormControl
                  type="password"
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  onChange={this.handleChange}
                />
              </FormGroup>

              {/* Error message display */}
              {this.state.errorMessage && (
                <div className="text-danger mb-3">
                  {this.state.errorMessage}
                </div>
              )}

              <Button
                type="submit"
                bsStyle="info"
                className="mt-2"
                disabled={
                  this.state.selectedRepos.length < 1 || this.state.addingUser
                }
              >
                {this.state.addingUser ? "Adding User..." : "Add User"}
              </Button>
            </form>
          </Col>

          {/* Right Column: Repository + Role Checkboxes */}
          <Col
            md={6}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ControlLabel>Grant access to these repositories:</ControlLabel>
            <div
              style={{
                height: "280px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "10px",
                marginTop: "5px",
              }}
            >
              {this.state.availableRepos
                .sort((x, y) => (x.owner < y.owner ? -1 : 1))
                .map((repo, i) => (
                  <Checkbox
                    key={i}
                    id={repo.nodeId}
                    onChange={this.handleRepoSelection}
                    className="mb-2"
                  >
                    {"   " + repo.owner + " / " + repo.folderName}
                  </Checkbox>
                ))}
            </div>

            <ControlLabel style={{ marginTop: "15px" }}>
              Assign roles to this user:
            </ControlLabel>
            <div
              style={{
                height: "280px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "10px",
                marginTop: "5px",
              }}
            >
              {this.state.availableRoles.map((role) => (
                <Checkbox
                  key={role.roleId}
                  id={String(role.roleId)}
                  onChange={this.handleRoleSelection}
                  checked={this.state.selectedRoles.some(
                    (selectedRole) => selectedRole.roleId === role.roleId,
                  )}
                  className="mb-2"
                >
                  {"   " + this.formatGroupName(role.roleName)}
                </Checkbox>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <Popup
        open={this.state.popupOpen}
        modal
        closeOnDocumentClick={false}
        onClose={this.closePopup}
        contentStyle={{
          width: "80%", // Make popup wider
          maxWidth: "900px", // Limit maximum width
          maxHeight: "92vh",
          overflowY: "auto",
          borderRadius: "10px",
          padding: "20px",
          background: "#fff", // White background
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div>
          {/* eslint-disable-next-line */}
          <a
            className="close"
            onClick={this.closePopup}
            style={{ color: "#999" }}
          >
            &times;
          </a>
          {this.renderCreateUser()}
        </div>
      </Popup>
    );
  }
}

export default CreateUserPopup;
